export default "/fonts/Acrom-ExtraBold.ttf?93238e2778a3d3e5a5bce8c2dd77f9f7";